import {
  ADMIN_CID_ANALYTICS_OVERVIEW_LOADED,
  ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED,
  ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED,
  ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED,
  ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED,
  ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED,
  ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED,
  ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED,
  ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED,
  ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED,
  ADMIN_CID_ANALYTICS_CLEAR,
} from '../../actions/actionTypes';

const initialState = {
  overview: null,
  creatorGrowth: null,
  revenueByMonth: null,
  revenueRanks: null,
  videoStats: null,
  weeklyGrowth: null,
  viewsAnalytics: null,
  claimsPerformance: null,
  revenuePerCreator: null,
  estimatedRevenue: null,
  filterOptions: null,
  ytAudits: null,
};

function cidAnalytics(state = initialState, action) {
  switch (action.type) {
    case ADMIN_CID_ANALYTICS_OVERVIEW_LOADED:
      return { ...state, overview: action.payload.data };
    case ADMIN_CID_ANALYTICS_CREATOR_GROWTH_LOADED:
      return { ...state, creatorGrowth: action.payload.data };
    case ADMIN_CID_ANALYTICS_REVENUE_BY_MONTH_LOADED:
      return { ...state, revenueByMonth: action.payload.data };
    case ADMIN_CID_ANALYTICS_REVENUE_RANKS_LOADED:
      return { ...state, revenueRanks: action.payload.data };
    case ADMIN_CID_ANALYTICS_VIDEO_STATS_LOADED:
      return { ...state, videoStats: action.payload.data };
    case ADMIN_CID_ANALYTICS_WEEKLY_GROWTH_LOADED:
      return { ...state, weeklyGrowth: action.payload.data };
    case ADMIN_CID_ANALYTICS_VIEWS_ANALYTICS_LOADED:
      return { ...state, viewsAnalytics: action.payload.data };
    case ADMIN_CID_ANALYTICS_CLAIMS_PERFORMANCE_LOADED:
      return { ...state, claimsPerformance: action.payload.data };
    case ADMIN_CID_ANALYTICS_REVENUE_PER_CREATOR_LOADED:
      return { ...state, revenuePerCreator: action.payload.data };
    case ADMIN_CID_ANALYTICS_ESTIMATED_REVENUE_LOADED:
      return { ...state, estimatedRevenue: action.payload.data };
    case ADMIN_CID_ANALYTICS_FILTER_OPTIONS_LOADED:
      return { ...state, filterOptions: action.payload.data };
    case ADMIN_CID_ANALYTICS_YT_AUDITS_LOADED:
      return { ...state, ytAudits: action.payload.data };
    case ADMIN_CID_ANALYTICS_CLEAR:
      return initialState;
    default:
      return state;
  }
}

export default cidAnalytics;
